module.exports = __webpack_public_path__ + "img/bg-unstoppable-domain.bf49834f.jpg";